module.exports = __webpack_public_path__ + "img/微信图片_20241212192556-p-130x130q80.94ace600.png";